import React from 'react';
import { AF_STATUS } from '../consts';
import { t } from '../multi-language/multi-lang.service';
function ArrythReportData(_a) {
    var _b, _c;
    var record = _a.record, avgData = _a.avgData;
    avgData = JSON.parse(avgData || '{}');
    var afStatus = avgData.af;
    var getCirclePIColor = function () {
        if (!+(avgData === null || avgData === void 0 ? void 0 : avgData.pi))
            return '';
        if (+(avgData === null || avgData === void 0 ? void 0 : avgData.pi) < 0.3)
            return 'red';
        if (+(avgData === null || avgData === void 0 ? void 0 : avgData.pi) < 0.4)
            return 'orange';
        if (+(avgData === null || avgData === void 0 ? void 0 : avgData.pi) < 0.6)
            return 'yellow';
        if (+(avgData === null || avgData === void 0 ? void 0 : avgData.pi) >= 0.6)
            return 'green';
    };
    var getAfStatusText = function () {
        return AF_STATUS[afStatus] || 'failed';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'info-bottom-section' },
            React.createElement("div", { className: "cardio-hide size-2 status-af ".concat(afStatus ? 'red-team' : 'green-team') }, t("af_status.".concat(getAfStatusText()))),
            React.createElement("div", { className: 'size-1 info-bottom' },
                React.createElement("hr", null),
                React.createElement("div", { className: "info-bottom-massure text-black" },
                    React.createElement("span", { className: 'pi-content' },
                        React.createElement("span", { className: "coloring-circle cardio-color-".concat(getCirclePIColor()) }),
                        t("arryth_report.pi"),
                        " \u2013 ",
                        (avgData === null || avgData === void 0 ? void 0 : avgData.pi) > 0 ? (_b = avgData === null || avgData === void 0 ? void 0 : avgData.pi) === null || _b === void 0 ? void 0 : _b.toFixed(2) : '00',
                        " %"),
                    React.createElement("span", null,
                        t("arryth_report.pwv"),
                        " \u2013 ",
                        (avgData === null || avgData === void 0 ? void 0 : avgData.pwv) > 0 ? (_c = avgData === null || avgData === void 0 ? void 0 : avgData.pwv) === null || _c === void 0 ? void 0 : _c.toFixed(2) : '00',
                        " ",
                        t("arryth_report.pwv_unit")))))));
}
export default ArrythReportData;
//# sourceMappingURL=arryth-report-data.js.map